<template>
  <div class="container">
    <app-bar
      title="Semua Voucher & Partnership"
      :previousLink="{ name: 'Home' }"
    />
    <Loading v-if="loading.getVoucherDetail" />
    <!-- <Empty v-else-if="vouchers.length < 1" :message="'Anda tidak memiliki voucher apapun.'"/> -->
    <div v-else>
      <div class="pt-md-4 px-3 px-md-2 mb-3">
        <ul class="nav nav-tabs d-flex">
          <li class="nav-item flex-fill text-center" role="button">
            <a class="nav-link" :class="{'active': filter === 'voucher'}" @click="filter = 'voucher'">Voucher Saya</a>
          </li>
          <li class="nav-item flex-fill text-center" role="button">
            <a class="nav-link" :class="{'active': filter === 'partnership'}" @click="filter = 'partnership'">Partnership</a>
          </li>
        </ul>
      </div>

      <div
        v-if="filter === 'voucher'"
        class="item-content d-flex flex-column px-2 px-md-0 mb-3 mb-md-0">
        <div
          v-for="voucher in vouchers"
          :key="voucher.id"
          class="container-voucher d-flex justify-content-between align-items-center p-2 ps-0"
          @click="openDetail(voucher)"
          role="button"
        >
          <div class="d-flex align-items-center gap-2">
            <div>
              <img :src="voucher.gambar" :alt="voucher.even">
            </div>
            <div class="description">
              <span>{{ voucher.even }}</span>
              <table class="text-muted fw-light">
                <tr>
                  <td>Berakhir Pada</td>
                  <td>: {{ extractDate(voucher.tgl_berakhir_voucher) }}</td>
                </tr>
                <tr>
                  <td>Diklaim Pada</td>
                  <td>: {{ extractDate(voucher.tgl_klaim) }}</td>
                </tr>
                <tr>
                  <td>Diredeem Pada</td>
                  <td>: {{ extractDate(voucher.tgl_redeem) }}</td>
                </tr>
              </table>
            </div>
          </div>
          <div>
            <button class="btn color-primary-500 rounded-pill fs-10">
              Pakai
            </button>
          </div>
        </div>

        <div class="bottom-bar d-flex justify-content-center p-3 border-0">
          <button class="btn color-primary-500 rounded-pill w-100">
            Tambahkan Voucher
          </button>
        </div>
      </div>

      <div
        v-if="filter === 'partnership'"
        class="item-content d-flex flex-column flex-md-row gap-4 px-2 px-md-0 mb-3"
      >
        <div
          v-for="partnership in partnerships"
          :key="partnership.idpromosi"
          class="container-partnership p-2 d-flex flex-column gap-2 col-12 col-md-6"
        >
          <div>
            <img :src="partnership.image_promo" :alt="partnership.judul_promo">
          </div>
          <div class="d-flex container-partnership-description justify-content-around py-2 px-3">
            <div class="w-50 d-flex align-items-center gap-2">
              <img src="@/assets/icon/discount.svg" alt="icon discount" class="dicount-icon">
              <span class="">{{ partnership.diskon }}</span>
            </div>
            <div class="w-50 d-flex align-items-center gap-2">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="flex-shrink-0">
                <path d="M8 5.75C7.59 5.75 7.25 5.41 7.25 5V2C7.25 1.59 7.59 1.25 8 1.25C8.41 1.25 8.75 1.59 8.75 2V5C8.75 5.41 8.41 5.75 8 5.75Z" fill="#292D32"/>
                <path d="M16 5.75C15.59 5.75 15.25 5.41 15.25 5V2C15.25 1.59 15.59 1.25 16 1.25C16.41 1.25 16.75 1.59 16.75 2V5C16.75 5.41 16.41 5.75 16 5.75Z" fill="#292D32"/>
                <path d="M8.5 14.4998C8.37 14.4998 8.24 14.4698 8.12 14.4198C7.99 14.3698 7.89 14.2998 7.79 14.2098C7.61 14.0198 7.5 13.7698 7.5 13.4998C7.5 13.3698 7.53 13.2398 7.58 13.1198C7.63 12.9998 7.7 12.8898 7.79 12.7898C7.89 12.6998 7.99 12.6298 8.12 12.5798C8.48 12.4298 8.93 12.5098 9.21 12.7898C9.39 12.9798 9.5 13.2398 9.5 13.4998C9.5 13.5598 9.49 13.6298 9.48 13.6998C9.47 13.7598 9.45 13.8198 9.42 13.8798C9.4 13.9398 9.37 13.9998 9.33 14.0598C9.3 14.1098 9.25 14.1598 9.21 14.2098C9.02 14.3898 8.76 14.4998 8.5 14.4998Z" fill="#292D32"/>
                <path d="M12 14.4999C11.87 14.4999 11.74 14.4699 11.62 14.4199C11.49 14.3699 11.39 14.2999 11.29 14.2099C11.11 14.0199 11 13.7699 11 13.4999C11 13.3699 11.03 13.2399 11.08 13.1199C11.13 12.9999 11.2 12.8899 11.29 12.7899C11.39 12.6999 11.49 12.6299 11.62 12.5799C11.98 12.4199 12.43 12.5099 12.71 12.7899C12.89 12.9799 13 13.2399 13 13.4999C13 13.5599 12.99 13.6299 12.98 13.6999C12.97 13.7599 12.95 13.8199 12.92 13.8799C12.9 13.9399 12.87 13.9999 12.83 14.0599C12.8 14.1099 12.75 14.1599 12.71 14.2099C12.52 14.3899 12.26 14.4999 12 14.4999Z" fill="#292D32"/>
                <path d="M15.5 14.4999C15.37 14.4999 15.24 14.4699 15.12 14.4199C14.99 14.3699 14.89 14.2999 14.79 14.2099C14.75 14.1599 14.71 14.1099 14.67 14.0599C14.63 13.9999 14.6 13.9399 14.58 13.8799C14.55 13.8199 14.53 13.7599 14.52 13.6999C14.51 13.6299 14.5 13.5599 14.5 13.4999C14.5 13.2399 14.61 12.9799 14.79 12.7899C14.89 12.6999 14.99 12.6299 15.12 12.5799C15.49 12.4199 15.93 12.5099 16.21 12.7899C16.39 12.9799 16.5 13.2399 16.5 13.4999C16.5 13.5599 16.49 13.6299 16.48 13.6999C16.47 13.7599 16.45 13.8199 16.42 13.8799C16.4 13.9399 16.37 13.9999 16.33 14.0599C16.3 14.1099 16.25 14.1599 16.21 14.2099C16.02 14.3899 15.76 14.4999 15.5 14.4999Z" fill="#292D32"/>
                <path d="M8.5 18.0002C8.37 18.0002 8.24 17.9702 8.12 17.9202C8 17.8702 7.89 17.8002 7.79 17.7102C7.61 17.5202 7.5 17.2602 7.5 17.0002C7.5 16.8702 7.53 16.7402 7.58 16.6202C7.63 16.4902 7.7 16.3802 7.79 16.2902C8.16 15.9202 8.84 15.9202 9.21 16.2902C9.39 16.4802 9.5 16.7402 9.5 17.0002C9.5 17.2602 9.39 17.5202 9.21 17.7102C9.02 17.8902 8.76 18.0002 8.5 18.0002Z" fill="#292D32"/>
                <path d="M12 18.0002C11.74 18.0002 11.48 17.8902 11.29 17.7102C11.11 17.5202 11 17.2602 11 17.0002C11 16.8702 11.03 16.7402 11.08 16.6202C11.13 16.4902 11.2 16.3802 11.29 16.2902C11.66 15.9202 12.34 15.9202 12.71 16.2902C12.8 16.3802 12.87 16.4902 12.92 16.6202C12.97 16.7402 13 16.8702 13 17.0002C13 17.2602 12.89 17.5202 12.71 17.7102C12.52 17.8902 12.26 18.0002 12 18.0002Z" fill="#292D32"/>
                <path d="M15.5 17.9999C15.24 17.9999 14.98 17.8899 14.79 17.7099C14.7 17.6199 14.63 17.5099 14.58 17.3799C14.53 17.2599 14.5 17.1299 14.5 16.9999C14.5 16.8699 14.53 16.7399 14.58 16.6199C14.63 16.4899 14.7 16.3799 14.79 16.2899C15.02 16.0599 15.37 15.9499 15.69 16.0199C15.76 16.0299 15.82 16.0499 15.88 16.0799C15.94 16.0999 16 16.1299 16.06 16.1699C16.11 16.1999 16.16 16.2499 16.21 16.2899C16.39 16.4799 16.5 16.7399 16.5 16.9999C16.5 17.2599 16.39 17.5199 16.21 17.7099C16.02 17.8899 15.76 17.9999 15.5 17.9999Z" fill="#292D32"/>
                <path d="M20.5 9.83984H3.5C3.09 9.83984 2.75 9.49984 2.75 9.08984C2.75 8.67984 3.09 8.33984 3.5 8.33984H20.5C20.91 8.33984 21.25 8.67984 21.25 9.08984C21.25 9.49984 20.91 9.83984 20.5 9.83984Z" fill="#292D32"/>
                <path d="M16 22.75H8C4.35 22.75 2.25 20.65 2.25 17V8.5C2.25 4.85 4.35 2.75 8 2.75H16C19.65 2.75 21.75 4.85 21.75 8.5V17C21.75 20.65 19.65 22.75 16 22.75ZM8 4.25C5.14 4.25 3.75 5.64 3.75 8.5V17C3.75 19.86 5.14 21.25 8 21.25H16C18.86 21.25 20.25 19.86 20.25 17V8.5C20.25 5.64 18.86 4.25 16 4.25H8Z" fill="#292D32"/>
              </svg>
              <span class="">{{ partnership.berlaku }}</span>
            </div>
          </div>
          <div>
            <span class="fw-bold fs-16">{{ partnership.judul_promo }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// mandatory
// import Empty from '@/components/utility/Empty'
import AppBar from '@/components/AppBar'
import Loading from '@/components/utility/Loading'
import { onMounted, ref } from 'vue'
import { showNotif } from '@/core/utility'
import { useRouter } from 'vue-router'

// data
import { loading, vouchers, voucherDetailExternal, getVouchers } from '@/core/voucher'
import { loading as loadingPartnership, partnerships, getPartnerships } from '@/core/partnership'

export default {
  components: {
    // Empty,
    AppBar,
    Loading
  },
  setup () {
    const filter = ref('voucher')
    const router = useRouter()

    const extractDate = (dateTime) => {
      if (!dateTime) {
        return '-'
      }

      const formatted = new Date(dateTime)
      if (!formatted) {
        return '-'
      }

      return formatted.toLocaleDateString('id-ID', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
      })
    }

    const openDetail = (voucher) => {
      if (!voucher) {
        return showNotif({
          status: 'error',
          message: 'Data voucher tidak valid'
        })
      }

      if (!voucher.info_detail) {
        return showNotif({
          status: 'error',
          message: 'Detail voucher tidak tersedia'
        })
      }

      voucherDetailExternal.value = voucher

      return router.push({
        name: 'VoucherDetailExternal'
      })
    }

    onMounted(async () => {
      await getVouchers()
      await getPartnerships()
    })

    return {
      loading,
      vouchers,
      filter,
      extractDate,
      openDetail,
      partnerships,
      loadingPartnership
    }
  }
}
</script>

<style lang="scss" scoped>
.container-voucher {
  border-radius: 15px;
  border: 1px solid #dee2e6;

  &::before{
    content: '';
    position: absolute;
    width: 25px;
    height: 25px;
    background: white;
    border-radius: 50%;
    border-right: 1px solid #dee2e6;
    margin-left: -15px;
  }

  .description {
    span {
      font-size: 12px;

      @media (min-width: 425px) {
        font-size: 14px;
      }
    }

    table {
      font-size: 8px;

      @media (min-width: 425px) {
        font-size: 12px;
      }
    }
  }

  img {
    width: 100px;
    height: auto;
  }
}

.container-partnership {
  border-radius: 15px;
  border: 1px solid #dee2e6;

  .container-partnership-description {
    border-radius: 15px;
    border: 1px solid #dee2e6;
  }

  img {
    height: auto;
    width: 100%;
  }

  .dicount-icon, svg {
    height: 30px;
    width: auto;
  }
}

.btn {
  border: 1px solid #dee2e6;
  padding: 10px 30px;
}
</style>
